import Vue      from 'vue'
import Router   from 'vue-router'
import Reroute  from '@/util/reroute'
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import config   from '@/config'

Vue.use(Router)

import paths    from './paths'
import navmenu  from './navmenu'


let routes = [
  ...paths,
  ...Reroute(navmenu(true),  config.apps),  
];

let unique = new Map(routes.map(obj => [obj.name, obj]));

const router =  new Router({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: unique
});
// router gards
router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach((to, from) => {
  // ...
  NProgress.done();
});

export default router;
